export default "__VITE_ASSET__DEoJkBiR__"